export default function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime@7.9.2@@babel/runtime/helpers/esm/setPrototypeOf.js
// module id = 440
// module chunks = 0